export enum LengthMetricUnitsEnum {
    mm = "MM",
    cm = "CM",
    m = "M",
    km = "KM",
    //...
}
